"use client";

import { Box, Container, List, ListItem, ListItemButton, ListItemText, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import { useRouter } from "next/navigation";
import MenuContext from "@/context/MenuProvider";
import color from "@/style/theme/Color";
import { mainBantuanNavMenus } from "@/layout/Navbar/Side/Sub/SubBantuan";

const menus = mainBantuanNavMenus;

const SubBantuan = () => {
  const router = useRouter();
  const { stateAppBar, setStateAppBar } = useContext(MenuContext)!;

  const toggleSubAppBar = (anchor: string, open: boolean) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setStateAppBar({ ...stateAppBar, [anchor]: open });
  };

  const closeSubAppBar = () => {
    setStateAppBar({
      subAppBarTentangKami: false,
      subAppBarKoleksi: false,
      subAppBarLayanan: false,
      subAppBarBantuan: false
    });
  };

  return <Box
    sx={{
      paddingTop: "1em",
      paddingBottom: "1em",
      width: "100%",
      backgroundColor: color.white_transparent,
      backdropFilter: "blur(10px)",
      position: "fixed",
      top: "64px",
      right: "0",
      left: "0",
      zIndex: "10"
    }}
    onMouseOver={toggleSubAppBar("subAppBarBantuan", true)}
    onMouseOut={closeSubAppBar}
  >
    <Container maxWidth="lg">
      <Stack direction="row" spacing={12}>
        <Typography sx={{ width: "300px", marginTop: "10px" }}>
          Dapatkan bantuan atau beri komentar mengenai perpustakaan dan layanannya.
        </Typography>

        <List>
          {menus.map((menu, key) => (
            <ListItem key={key} disablePadding>
              <ListItemButton
                href={menu.path ?? '#'}
                sx={{
                  borderBottom: "1px solid rgb(230,230,230)",
                  borderLeft: "1px solid rgb(230,230,230)"
                }}
              >
                <ListItemText primary={menu.title}/>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Stack>
    </Container>
  </Box>;
};

export default SubBantuan;
